const SettlementStatusEnum = Object.assign({
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  ROLLBACK: 'ROLLBACK',
  NEEDS_MANUAL_SOLVING: 'NEEDS_MANUAL_SOLVING',
});

Object.freeze(SettlementStatusEnum);

export default SettlementStatusEnum;



// WEBPACK FOOTER //
// ./src/enum/settlements/SettlementStatus.js